import { useTranslations } from '@vocab/react';
import { Box, Text, TextLinkButton, IconCompose } from 'braid-design-system';

import translations from './.vocab';

import * as styles from './CreateThreadButton.css';

interface CreateTheadButtonProps {
  onClick?: () => void;
}

export default ({ onClick }: CreateTheadButtonProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box paddingTop="medium" className={styles.CreateThreadButton}>
      <Text>
        <TextLinkButton
          icon={
            <span style={{ paddingRight: '16px' }}>
              <IconCompose />
            </span>
          }
          onClick={onClick}
          iconPosition="leading"
        >
          {t('threadCreate')}
        </TextLinkButton>
      </Text>
    </Box>
  );
};
